import * as React from "react";
import Dialog from "@mui/material/Dialog";
import List from "@mui/material/List";

import Slide from "@mui/material/Slide";
import ProductTab from "./ProductTogetherTab";

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function BoughtTogether ({ open, handleClose, product, getProductDetails }) {
  return (
    <React.Fragment>
      <Dialog
        // style={{ border: "1px solid orange" }}
        fullScreen
        open={open}
        TransitionComponent={Transition}
      >
        <List>
          <ProductTab product={product} handleClose={handleClose} getProductDetails={getProductDetails} />
        </List>
      </Dialog>
    </React.Fragment>
  );
}
